import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { useIsMobile } from 'hooks/useIsMobile';
import { CommandPalette } from './command-palette';

export const SearchBar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const isMac = /Mac/i.test(navigator.userAgent);

  const isInputFocused = () => {
    const activeElement = document.activeElement as HTMLElement;
    return (
      activeElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable)
    );
  };

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      // Toggle search bar on 'Ctrl + K' (Cmd + K for macOS)
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k' && !isInputFocused()) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  return (
    <>
      <button
        className="pointer-cursor flex h-10 items-center rounded-md border border-solid border-input bg-background 
        px-3 py-2 pr-10 text-sm text-muted-foreground md:pr-24 lg:w-[230px]"
        onClick={() => setOpen(true)}
      >
        <Search className="h-6 pr-2" />
        {isMobile ? (
          <p>Search...</p>
        ) : (
          <>
            Type
            <kbd
              className="pointer-events-none mx-1 inline-flex h-5 select-none items-center 
        gap-1 whitespace-nowrap rounded bg-muted px-1 font-mono opacity-100"
            >
              {isMac ? 'Cmd+K' : 'Ctrl+K'}
            </kbd>
            <p className="whitespace-nowrap">to search</p>
          </>
        )}
      </button>
      <CommandPalette open={open} setOpen={setOpen} />
    </>
  );
};
